module.exports = __webpack_public_path__ + "static/Montaz_wspornika_plotka_rur_typ_C-524654d89499680f6a10078aed135ccb.pdf";